import { CdnAsset } from "#components/ui/CdnAsset.tsx";
import { CustomButton } from "#components/ui/CustomButton.tsx";
import { type BackgroundColorValue, type ButtonProps, type ColorValue, Flex, Text, useColorSchemeValue } from "@hopper-ui/components";
import { ArrowUpIcon } from "@hopper-ui/icons";
import { IconAssets } from "@workleap-ai/shared/types";
import "./SuggestedPrompt.css";

interface Props extends Omit<ButtonProps, "children"> {
    text: string;
}

export function SuggestedPrompt({ text, onPress, ...rest }: Props) {
    const borderColor = useColorSchemeValue(
        "orchid-bloom-100",
        "rock-500"
    ) as ColorValue;

    const textColor = useColorSchemeValue(
        "core_orchid-bloom-600",
        "neutral-weak"
    ) as ColorValue;

    const arrowBgColor = useColorSchemeValue(
        "core_orchid-bloom-50",
        "core_orchid-bloom-600"
    ) as BackgroundColorValue;

    const arrowTextColor = useColorSchemeValue(
        "core_orchid-bloom-500",
        "core_samoyed"
    ) as ColorValue;

    const backgroundColorHover = useColorSchemeValue(
        "core_orchid-bloom-25",
        "core_rock-800"
    ) as BackgroundColorValue;

    return (
        <CustomButton
            backgroundColor="transparent"
            paddingLeft="inset-md"
            paddingRight="inset-sm"
            paddingY="inset-sm"
            UNSAFE_border={`0.0625rem solid var(--hop-${borderColor})`}
            borderRadius="pill"
            backgroundColorHover={backgroundColorHover}
            maxWidth="100%"
            className="wai-suggested-prompt"
            onPress={onPress}
            {...rest}
        >
            <Flex
                alignItems="center"
                gap="inline-sm"
                textAlign="left"
            >
                <CdnAsset
                    asset={IconAssets.WorkleapAi}
                    alt=""
                    width="core_160"
                    height="core_160"
                />
                <Flex
                    alignItems="center"
                    gap={{ base: "inline-xs", sm: "inline-md" }}
                    UNSAFE_lineHeight="1.25rem"
                    color={textColor}
                >
                    <Text size={rest.size} className="wai-suggested-prompt-text">
                        {text}
                    </Text>
                    <Flex
                        backgroundColor={arrowBgColor}
                        borderRadius="circle"
                        UNSAFE_width="core_240"
                        UNSAFE_height="core_240"
                        alignItems="center"
                        justifyContent="center"
                        shrink="0"
                        color={arrowTextColor}
                        className="wai-suggested-prompt-arrow"
                    >
                        <ArrowUpIcon size="sm" />
                    </Flex>
                </Flex>
            </Flex>
        </CustomButton>
    );
}
